module.exports = __webpack_public_path__ + "img/Judi.a25c53f.png";